import { render } from "./CompanyWhitelabelRouter.vue?vue&type=template&id=bef8327c&scoped=true"
import script from "./CompanyWhitelabelRouter.vue?vue&type=script&lang=js"
export * from "./CompanyWhitelabelRouter.vue?vue&type=script&lang=js"

import "./CompanyWhitelabelRouter.vue?vue&type=style&index=0&id=bef8327c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bef8327c"]])

export default __exports__